import React, { Component } from 'react';
import Select from 'react-select';
import { Translation } from 'react-i18next';

import { education } from '../../copy/onboardingCopy.json';

class HighSchoolInputs extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  checkAdvisorDashboardStatus = (error) => {
    if (this.props.advisorDashboard) {
      return error
        ? 'form-register error custom-school edit-profile-input'
        : 'form-register custom-school edit-profile-input';
    }
    return error
      ? 'form-register error custom-school'
      : 'form-register custom-school';
  };

  customSchoolInput(
    highSchool,
    customSchool,
    handleErrors,
    errors,
    onInputChange
  ) {
    return highSchool !== 'Other' ? (
      <div className="hidden-input" />
    ) : (
      <input
        onBlur={(event) => {
          handleErrors(event, customSchool);
        }}
        type="text"
        onChange={onInputChange}
        placeholder="High School Name"
        className={this.checkAdvisorDashboardStatus(errors.customSchool)}
        id="customSchool"
        name="customSchool"
      />
    );
  }

  render() {
    const {
      onboarding,
      errors,
      handleErrors,
      primary,
      highSchool,
      customSchool,
      graduationYear,
      handleHighSchoolSelected,
      handleYearSelected,
      onInputChange,
      userEducationLevel,
      userCountry,
      advisorDashboard,
    } = this.props;
    const customStyles = {
      option: (provided) => ({
        ...provided,
        color: primary,
      }),
      input: (provided) => ({
        ...provided,
        color: primary,
        width: '100%',
      }),
      placeholder: (provided) => ({
        ...provided,
        color: primary,
      }),
      singleValue: (provided) => ({
        ...provided,
        color: primary,
        overflow: 'visible',
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        color: primary,
      }),
      menuPortal: (provided) => ({
        ...provided,
        zIndex: 100,
      }),
    };

    const advisorDashboardStyles = {
      control: (provided) => ({
        ...provided,
        height: '100%',
        borderRadius: '7px',
      }),
      option: (provided) => ({
        ...provided,
        color: primary,
      }),
      input: (provided) => ({
        ...provided,
        color: primary,
      }),
      placeholder: (provided) => ({
        ...provided,
        color: 'black',
        paddingLeft: '12px',
      }),
      singleValue: (provided) => ({
        ...provided,
        color: 'black',
        overflow: 'visible',
        paddingLeft: '12px',
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        paddingRight: '6px',
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        color: primary,
      }),
      indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
      }),
    };

    const currentYear = new Date().getFullYear();
    const isInternationalStudent = ['United States'].indexOf(userCountry) >= 0;

    const yearChoices = [
      { value: currentYear, label: currentYear },
      { value: currentYear + 1, label: currentYear + 1 },
      { value: currentYear + 2, label: currentYear + 2 },
      { value: currentYear + 3, label: currentYear + 3 },
      { value: currentYear + 4, label: currentYear + 4 },
    ];

    const getHighSchoolDropdown = (t) => {
      return (
        <div
          className={
            advisorDashboard
              ? 'edit-profile-select'
              : 'dropdown select-highschool'
          }
        >
          <Select
            menuPortalTarget={document.body}
            onChange={handleHighSchoolSelected}
            options={onboarding.highSchools}
            className="dropdown-select"
            id="highSchool"
            styles={advisorDashboard ? advisorDashboardStyles : customStyles}
            placeholder={highSchool || t('Highschool Name')}
            aria-label={highSchool || t('Highschool Name')}
          />
        </div>
      );
    };

    const getYearDropdown = (t) => {
      return (
        <div className="dropdown select-graduation">
          <Select
            menuPortalTarget={document.body}
            onChange={handleYearSelected}
            options={yearChoices}
            className="dropdown-select"
            id="graduationYear"
            styles={customStyles}
            placeholder={graduationYear || t('Graduation Year')}
            aria-label={graduationYear || t('Graduation Year')}
          />
        </div>
      );
    };

    if (userEducationLevel === education.degree2) {
      return (
        <Translation>
          {(t) => (
            <div
              className="highschool-info-container"
              data-cy="highschool-fields"
            >
              {!advisorDashboard && (
                <h2 className="highschool-header">
                  {isInternationalStudent
                    ? t('Tell Us About Your High School')
                    : t('Tell Us About Your Secondary School')}
                </h2>
              )}
              {isInternationalStudent
                ? getHighSchoolDropdown(t)
                : getYearDropdown(t)}
              <div>
                {this.customSchoolInput(
                  highSchool,
                  customSchool,
                  handleErrors,
                  errors,
                  onInputChange
                )}
              </div>
              {isInternationalStudent &&
                !advisorDashboard &&
                getYearDropdown(t)}
            </div>
          )}
        </Translation>
      );
    }

    return <div className="hidden-input" />;
  }
}

export default HighSchoolInputs;
